import { render, staticRenderFns } from "./agv-magnet.vue?vue&type=template&id=3e22762c&scoped=true&lang=pug&"
import script from "./agv-magnet.vue?vue&type=script&lang=js&"
export * from "./agv-magnet.vue?vue&type=script&lang=js&"
import style0 from "./agv-magnet.vue?vue&type=style&index=0&id=3e22762c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e22762c",
  null
  
)

export default component.exports